{
  "settings": {
    "sections": {
      "booking": {
        "label": "Online-Terminbuchung",
        "hint": "Wie Patienten selbst bei Ihnen buchen, und Ihre freien Tage, je Klinik"
      }
    },
    "onlineBooking": {
      "regionLabel": "Online-Terminbuchung in Ihren Kliniken",
      "cardSubtitle": "Patienten buchen selbst in der Patienten-App und auf Ihrer Seite",
      "unnamedClinic": "Klinik ohne Namen",
      "loadFailed": "Die Einstellungen zur Online-Terminbuchung sind nicht verfügbar.",
      "saved": "Einstellung zur Online-Terminbuchung gespeichert.",
      "saveFailed": "Die Einstellung wurde nicht gespeichert. Bitte versuchen Sie es erneut.",
      "allow": {
        "label": "Patienten können selbst online Termine buchen",
        "impact": "Ausgeschaltet werden für Sie in dieser Klinik weder in der Patienten-App noch auf Ihrer Seite Online-Termine angezeigt. Buchungen durch die Anmeldung bleiben unverändert."
      },
      "horizon": {
        "label": "Bis wie viele Tage im Voraus",
        "unit": "Tage",
        "placeholder": "Das Limit der Klinik",
        "clinicCap": "Limit der Klinik: {{days}} Tage",
        "effective": "Patienten können jetzt bis zu {{days}} Tage im Voraus buchen.",
        "effectiveNone": "Mit dem aktuellen Limit der Klinik können Patienten derzeit nicht online buchen.",
        "capped": "Ihre Zahl liegt über dem Limit der Klinik; es gelten deren {{days}} Tage.",
        "paused": "Ihre Online-Terminbuchung in dieser Klinik ist pausiert.",
        "invalid": "Geben Sie eine Zahl von 1 bis 365 ein oder lassen Sie das Feld leer, damit das Limit der Klinik gilt."
      },
      "warnings": {
        "noPresence": "Ihre Anwesenheitszeiten in dieser Klinik sind nicht erfasst; es wird keine Online-Terminbuchung angezeigt.",
        "noPresenceHint": "Die Anmeldung der Klinik erfasst Ihre Anwesenheitszeiten.",
        "clinicClosed": "Diese Klinik nimmt derzeit keine Online-Buchungen von Patienten an.",
        "clinicClosedHint": "Ihre Einstellung gilt, sobald die Klinik die Online-Terminbuchung einschaltet."
      },
      "empty": {
        "title": "Sie sind in keiner Klinik Mitglied",
        "hint": "Die Online-Terminbuchung wird für Kliniken eingestellt, in denen Ihre Mitgliedschaft angenommen ist.",
        "action": "Zu den Kliniken"
      },
      "daysOff": {
        "title": "Freie Tage",
        "hint": "An diesen Tagen können weder Patienten noch die Anmeldung Termine bei Ihnen in dieser Klinik buchen. Bereits gebuchte Termine bleiben unverändert.",
        "add": "Freien Tag hinzufügen",
        "empty": "Keine bevorstehenden freien Tage.",
        "emptyHint": "Tragen Sie die Tage ein, an denen Sie nicht da sind – Reise, Kongress, Krankheit.",
        "loadFailed": "Die freien Tage sind nicht verfügbar.",
        "wholeDay": "Ganztägig",
        "hours": "{{start}} bis {{end}}",
        "range": "{{from}} bis {{to}}",
        "remove": "Entfernen",
        "removeAria": "Freie Tage {{range}} entfernen",
        "removeTitle": "Freien Tag entfernen",
        "removeBody": "Die freien Tage {{range}} in „{{clinic}}“ entfernen? Danach kann an diesen Tagen wieder bei Ihnen gebucht werden.",
        "removeConfirm": "Entfernen",
        "removed": "Freier Tag entfernt.",
        "removeFailed": "Der freie Tag wurde nicht entfernt."
      },
      "dayOff": {
        "title": "Freien Tag hinzufügen",
        "subtitle": "In „{{clinic}}“",
        "from": "Von",
        "to": "Bis (optional)",
        "toHint": "Leer lassen für nur diesen einen Tag.",
        "span": "Dauer",
        "spanWhole": "Ganztägig",
        "spanPart": "Teil des Tages",
        "start": "Ab",
        "end": "Bis",
        "partHint": "Diese Uhrzeiten gelten an jedem Tag des Zeitraums.",
        "reason": "Grund (optional)",
        "reasonPlaceholder": "z. B. ein Kongress",
        "submit": "Freien Tag speichern",
        "saveFailed": "Der freie Tag wurde nicht gespeichert.",
        "errors": {
          "from": "Wählen Sie das Startdatum.",
          "order": "Das Enddatum darf nicht vor dem Startdatum liegen.",
          "range": "Freie Tage dürfen höchstens 366 Tage umfassen.",
          "past": "Freie Tage dürfen nicht vor heute enden.",
          "hours": "Die Startzeit muss vor der Endzeit liegen."
        }
      }
    }
  },
  "errors": {
    "bff": {
      "onboarding": {
        "clinicListUnavailable": "Die Liste der Kliniken ist nicht verfügbar."
      },
      "onlineBooking": {
        "notMember": "Sie sind kein angenommenes Mitglied dieser Klinik.",
        "settingsLoad": "Die Einstellungen zur Online-Terminbuchung konnten nicht geladen werden.",
        "settingsSave": "Die Einstellungen zur Online-Terminbuchung konnten nicht gespeichert werden.",
        "horizonInvalid": "Die Anzahl der Tage muss zwischen 1 und 365 liegen; für das Limit der Klinik leer lassen.",
        "invalid": "Die eingegebenen Angaben sind nicht gültig.",
        "daysOffLoad": "Die freien Tage konnten nicht geladen werden.",
        "dayOffSave": "Der freie Tag konnte nicht gespeichert werden.",
        "dayOffRemove": "Der freie Tag konnte nicht entfernt werden.",
        "dayOffNotFound": "Dieser freie Tag wurde nicht gefunden.",
        "dayOffDate": "Das Datum der freien Tage ist nicht gültig.",
        "dayOffOrder": "Das Enddatum der freien Tage darf nicht vor ihrem Startdatum liegen.",
        "dayOffRange": "Freie Tage dürfen höchstens 366 Tage umfassen.",
        "dayOffPast": "Freie Tage dürfen nicht vor heute enden.",
        "dayOffMinutes": "Die Startzeit der freien Tage muss vor ihrer Endzeit liegen."
      }
    }
  }
}
